import { colors } from 'design-system';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const PlusIcon = ({
  width = 19,
  height = 22,
  color = colors.madison,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M17.6773 7.83446L17.6943 12.2465L0.151497 12.3141L0.134497 
        7.90206L17.6773 7.83446ZM11.2873 0.915671L11.3591 19.5483L6.56035 
        19.5668L6.48855 0.934162L11.2873 0.915671Z"
      fill={color}
    />
  </VectorIcon>
);

export default PlusIcon;
